export default "<!--The content below is only a placeholder and can be replaced.-->\n<lib-xodos></lib-xodos><!-- \n<app-welcomepage></app-welcomepage> -->\n\n";